<div class="versus-layout">
  <div class="versus-image-container">
    <img [src]="imageUrl()" alt="You vs Opponent" class="versus-image" />
    <div class="player-labels" [style.bottom]="labelBottom()">
      <div class="player-label">
        <span [ngStyle]="contentStyles | theme">{{ youLabel }}</span>
      </div>
      <div class="player-label">
        <span [ngStyle]="contentStyles | theme">{{ opponentLabel }}</span>
      </div>
    </div>
  </div>
</div>
<p class="slide-description" [ngStyle]="descriptionStyles | theme">{{ description() }}</p>
